import React from 'react';
import { ArrowRightIcon, CalendarDaysIcon, ClockIcon, PrinterIcon } from 'lucide-react';
import { volumeCoverImage, weeks } from '../data/kit';
const steps = [{
  Icon: CalendarDaysIcon,
  label: '01 · PREPARE',
  title: 'Know what you need.',
  text: 'See the purpose, materials and quantities, space arrangement and opening words before the children arrive.'
}, {
  Icon: ClockIcon,
  label: '02 · LEAD',
  title: 'Know what happens next.',
  text: 'Follow the welcome, warm-up, main activity, team challenge, reset and closing in a timed sequence.'
}, {
  Icon: PrinterIcon,
  label: '03 · PRINT & ADAPT',
  title: 'Have the resources ready.',
  text: 'Use the session’s cards, models and answers, with ways to adjust the difficulty and available space.'
}];
export function InsideSection() {
  return <section className="section light" id="inside" data-id="element-112" data-mp="z6t2bucj7p3w">
      <div className="wrap" data-id="element-113" data-mp="1488ppt26m7pg">
        <div className="section-heading" data-id="element-114" data-mp="147gu4i8l49z6">
          <p className="eyebrow" data-id="element-115" data-mp="2zvtjsx5cl0n5">The weekly playbook</p>
          <h2 data-id="element-116" data-mp="2zuicwoglvcrt">
            Inside Volume 1:
            <br data-id="element-117" data-mp="2vuq2e67niwjt" />
            <span className="accent" data-id="element-118" data-mp="2vv9nfvslm122">Play, Connect & Cooperate</span>
          </h2>
        </div>
        <article className="volume-card" data-id="element-119" data-mp="39m4ncil4d7ti">
          <div className="volume-art" data-id="element-120" data-mp="39l39y7gms98m">
            <img src={volumeCoverImage} alt="Cover of Kids Activity Club Volume 01: Play, Connect & Cooperate" loading="lazy" data-id="element-121" data-mp="34n1udwieys1w" />
          </div>
          <div data-id="element-122" data-mp="2cvvn8w49zu34">
            <p className="eyebrow" data-id="element-123" data-mp="2cwdt8kgqpmo8">VOLUME 01 · WEEKS 1–13</p>
            <h3 data-id="element-124" data-mp="2cxyne8z573lk">A clear plan for every encounter.</h3>
            <p data-id="element-125" data-mp="2qwex88saxa7x">
              Thirteen themed sessions bring movement, observation, memory, simple logic and cooperation together.
              Each one tells you what to prepare, what to say and what to do next.
            </p>
            <p className="features" data-id="element-126" data-mp="63bgeomujh8b">Materials · Setup · Scripts · Timings · Resources · Adaptations</p>
            <p style={{
            marginTop: 16,
            fontSize: 12
          }} data-id="element-127" data-mp="185u3opj80jp">
              Designed for ages 5–8, with a 12-child working example and guidance for groups of 6–16. Timings are
              estimates you adapt to your group.
            </p>
          </div>
        </article>
        <div className="inside-cards" data-id="element-128" data-mp="i8qrs9qvozis">
          {steps.map(({
          Icon,
          label,
          title,
          text
        }) => <article key={label} className="inside-card" data-id="element-129" data-mp="n57fx3y2vdvv">
              <p className="eyebrow" data-id="element-130" data-mp="3lofq8u4nl87i">
                <span className="mini-icon" data-id="element-131" data-mp="3lph230thtyqa">
                  <Icon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-132" data-mp="3lmbfptc91ay9" />
                </span>
                {label}
              </p>
              <h3 data-id="element-133" data-mp="3vlan78la30jo">{title}</h3>
              <p data-id="element-134" data-mp="3vl0v9fgoajbc">{text}</p>
            </article>)}
        </div>
        <details className="weeks-details" data-id="element-135" data-mp="48poyor1zi0o">
          <summary data-id="element-136" data-mp="49hd5eibmdgx">See the full 13-week plan</summary>
          <ol className="week-list" data-id="element-137" data-mp="32wmu4quaf6vk">
            {weeks.map((week, i) => <li key={week} data-id="element-138" data-mp="37w7tv3ha7j9c" data-mpi={i}>
                <span data-id="element-139" data-mp="37vg9kot4x7yd">{String(i + 1).padStart(2, '0')}</span>
                {week}
              </li>)}
          </ol>
        </details>
        <div className="section-cta" data-id="element-140" data-mp="2ve5iadyxvfzf">
          <a href="#offer-details" className="cta" data-id="element-141" data-mp="2vf6x8tj2smmf">
            SEE THE COMPLETE KIT <ArrowRightIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-142" data-mp="2qej687uuk5s7" />
          </a>
        </div>
      </div>
    </section>;
}